import { Card, Input, Form, FormInstance } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useWatch } from 'antd/es/form/Form'
import { defaultTitle } from '../../../../../../../redux/context/customReports/transUtils'
import CategoryTitlePreview from './CategoryTitlePreview'
import { ReportGrammarRules } from '../../../../../../../redux/config/customReport/types'
import { NormalizedBuilderNode, NodesById, VisitorContext } from '../types'

export interface CategoryFormData {
  title: string
}

const { TextArea } = Input

interface CategorySettingsFormProps {
  node: NormalizedBuilderNode
  form: FormInstance<CategoryFormData>
  rules: ReportGrammarRules
  context: VisitorContext
  nodesById: NodesById
}

const CategorySettingsForm: React.FC<CategorySettingsFormProps> = ({
  node: category,
  form,
  rules,
  context,
  nodesById
}) => {
  const { t } = useTranslation()
  const newTitle = useWatch('title', form)

  // Alusta lomake olemassa olevalla datalla
  useEffect(() => {
    // Muunnetaan objekti listaksi avain-arvo pareja
    const initialValues = {
      title: category.title ?? defaultTitle(category.type, category.value)
    }
    form.setFieldsValue(initialValues)
  }, [category])

  return (
    <div style={{ maxWidth: 600, margin: '0 auto' }}>
      <Form form={form} layout="vertical" data-cy={`category-settings-form-${category.id}`}>
        <Card style={{ marginBottom: 24 }}>
          <Form.Item name="title" label={t('global:title')}>
            <TextArea
              rows={5}
              spellCheck={false}
              placeholder={t('global:title')}
              data-cy={`category-title-input-${category.id}`}
            />
          </Form.Item>
          <Form.Item label={t('customReportPage:generatedTitle')}>
            <Card>
              <CategoryTitlePreview
                newTitle={newTitle}
                category={category}
                rules={rules}
                context={context}
                nodesById={nodesById}
              />
            </Card>
          </Form.Item>
        </Card>
      </Form>
    </div>
  )
}

export default CategorySettingsForm
